import { render, staticRenderFns } from "./MarkahKomponen.vue?vue&type=template&id=362888f6&scoped=true&"
import script from "./MarkahKomponen.vue?vue&type=script&lang=js&"
export * from "./MarkahKomponen.vue?vue&type=script&lang=js&"
import style0 from "./MarkahKomponen.vue?vue&type=style&index=0&id=362888f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362888f6",
  null
  
)

export default component.exports